import React from 'react';
import '../App.css';

export default function Footer({pageChanged}) {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-grid">
          <div className="footer-brand">
            <div className="footer-name">Gridspot</div>
            <p>The Convenient Solution for <br/> Keeping Your EV Powered.</p>
          </div>
          <div>
            <h2>Company</h2>
            <ul>
              <li><a href="https://www.gridspot.co/blog">Blog</a></li>
              <li><span>Careers</span></li>
            </ul>
          </div>
          <div>
            <h2>Resources</h2>
            <ul>
              <li><span>Documentation</span></li>
              <li><button type="button" onClick={() => pageChanged('contact')}>Contact Us</button></li>
              <li><span>Press Conferences</span></li>
            </ul>
          </div>
          <div>
            <h2>Legal</h2>
            <ul>
              <li><a href="https://www.gridspot.co/nondiscrimination">Non-Discrimination Policy</a></li>
              <li><a href="https://www.gridspot.co/privacy">Privacy Policy</a></li>
              <li><a href="https://www.gridspot.co/terms">Terms of Service</a></li>
            </ul>
          </div>
        </div>
        <div className="footer-bottom">© 2023 Gridspot. All rights reserved.</div>
      </div>
    </footer>
  )
}
